export const credentialsStorageKey = 'graycecredentials';

export const drugSelectOther = 'other';
export const employerSelectSelfPaid = 'self_paid';

export const fifteenMinutesInMs = 15 * 60 * 1000;
export const fiveDaysInMs = 5 * 24 * 60 * 60 * 1000;
export const fiveMinutesInMs = 5 * 60 * 1000;
export const oneDayInMs = 24 * 60 * 60 * 1000;
export const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;
export const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
export const thirtySecondsInMs = 30 * 1000;
export const threeDaysInMS = 3 * 24 * 60 * 60 * 1000;
